const TAG_JOBSHEET = "Jobsheet";
const TAG_PURCHASEORDER = "Purchase Order";
const TAG_DIAGRAM = "Job Diagram";
const TAG_WARRANTY = "Warranty";

export default {
    TAG_JOBSHEET,
    TAG_PURCHASEORDER,
    TAG_DIAGRAM,
    TAG_WARRANTY,
    tags: [
        TAG_JOBSHEET,
        TAG_PURCHASEORDER,
        TAG_DIAGRAM,
        TAG_WARRANTY
    ]
}